import {FormikConfig} from 'formik';

export const main: Pick<FormikConfig<any>, 'validate'>['validate'] = (
  values: any
) => {
  const errors: any = {};

  if (!values.email) {
    errors.email = 'メールアドレスを入力してください';
  }
  if (!values.password) {
    errors.password = 'パスワードを入力してください';
  }

  return errors;
};
